import { useRef, useState } from 'react'
import { GuidePicker } from '../guides/GuidePicker'
import './ChatInput.css'

const IconSend = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="22" y1="2" x2="11" y2="13" />
    <polygon points="22 2 15 22 11 13 2 9 22 2" />
  </svg>
)

// Message composer for a chat window: an auto-growing multi-line textarea with a
// send button. Enter sends, Shift+Enter inserts a newline. Keeps its own draft
// text and clears it after a successful send.
function ChatInput({
  placeholder = 'Message',
  onSend,
  disabled,
  models = [],
  model,
  onModelChange,
}) {
  const [text, setText] = useState('')
  const [guides, setGuides] = useState([])
  const ref = useRef(null)

  const resize = () => {
    const el = ref.current
    if (!el) return
    el.style.height = 'auto'
    el.style.height = `${Math.min(el.scrollHeight, 140)}px`
  }

  const send = () => {
    const trimmed = text.trim()
    if (!trimmed || disabled) return
    onSend?.(trimmed, { guides })
    setText('')
    setGuides([])
    requestAnimationFrame(resize)
  }

  return (
    <div className="chat-input">
      <div className="chat-input-guides">
        <GuidePicker value={guides} onChange={setGuides} />
      </div>
      <div className="chat-input-box">
        <textarea
          ref={ref}
          className="chat-input-textarea"
          rows={1}
          value={text}
          placeholder={placeholder}
          disabled={disabled}
          onChange={(event) => {
            setText(event.target.value)
            resize()
          }}
          onKeyDown={(event) => {
            if (event.key === 'Enter' && !event.shiftKey) {
              event.preventDefault()
              send()
            }
          }}
        />
        {models.length > 0 && (
          <select
            className="chat-input-model"
            value={model || ''}
            title="Model"
            aria-label="Model"
            disabled={disabled}
            onChange={(event) => onModelChange?.(event.target.value)}
          >
            {models.map((m) => (
              <option key={m.key} value={m.key}>
                {m.label}
              </option>
            ))}
          </select>
        )}
        <button
          type="button"
          className="chat-input-send"
          title="Send"
          aria-label="Send"
          onClick={send}
          disabled={disabled || !text.trim()}
        >
          <IconSend />
        </button>
      </div>
    </div>
  )
}

export default ChatInput
